import { useState } from 'react'

import PhatDropdown from 'components/formElements/PhatDropdown'

import styles from './customCardsOrderByDropdown.module.scss'

type Props = {
  value?: string
  orderByDescending?: boolean
  onChange?: (orderBy: string, orderDirection: 'ascending' | 'descending') => void
  callBackOnDirectionChange?: boolean
  menuClassName?: string
  triggerClassName?: string
}

const CustomCardsOrderByDropdown = ({
  value: parentValue,
  orderByDescending: parentOrderByDescending,
  callBackOnDirectionChange,
  onChange,
  menuClassName = '',
  triggerClassName,
}: Props) => {
  const [value, setValue] = useState(parentValue || 'name')
  const [orderByDesc, setOrderByDesc] = useState(parentOrderByDescending || false)

  const handleSetDirection = (orderByDescending: boolean) => {
    setOrderByDesc(orderByDescending)

    if (callBackOnDirectionChange && onChange) onChange(value, orderByDescending ? 'descending' : 'ascending')
  }

  const handleSetOrder = (orderBy: string) => {
    setValue(orderBy)

    // Note - we only report to the parent when the actual value changes - NOT when the order by direction changes.
    // This is intentional since we don't want to trigger a refresh if someone wants to change the direction THEN pick a new order by
    // If we ever need to update by the order by direction, add a new onChange prop
    if (onChange) onChange(orderBy, orderByDesc ? 'descending' : 'ascending')
  }

  return (
    <PhatDropdown
      header="Sort by"
      value={value}
      triggerClassName={triggerClassName}
      menuClassName={`${styles.orderByMenu} ${menuClassName}`}
      icon={orderByDesc ? 'sort amount down' : 'sort amount up'}
      options={[
        {
          type: 'checkbox',
          label: 'Sort descending',
          onChange: () => handleSetDirection(!orderByDesc),
          checked: orderByDesc,
        },
        { type: 'spacer' },
        {
          label: 'Date updated',
          icon: 'edit outline',
          id: 'updatedAt',
          onClick: () => handleSetOrder('updatedAt'),
        },
        {
          label: 'Date added',
          icon: 'calendar alternate outline',
          id: 'createdAt',
          onClick: () => handleSetOrder('createdAt'),
        },

        { type: 'spacer' },
        {
          label: 'Card name',
          icon: 'font',
          id: 'name',
          onClick: () => handleSetOrder('name'),
        },
        {
          label: 'Type',
          icon: 'tag',
          id: 'type',
          onClick: () => handleSetOrder('type'),
        },
        {
          label: 'Edition code',
          icon: 'clone',
          id: 'set',
          onClick: () => handleSetOrder('set'),
        },
        {
          label: 'Mana value',
          icon: 'sort numeric down',
          id: 'manaValue',
          onClick: () => handleSetOrder('manaValue'),
        },
        {
          label: 'Power',
          icon: 'bolt',
          id: 'power',
          onClick: () => handleSetOrder('power'),
        },
        {
          label: 'Toughness',
          icon: 'shield alternate',
          id: 'toughness',
          onClick: () => handleSetOrder('toughness'),
        },
        {
          label: 'Loyalty',
          icon: 'heart',
          id: 'loyalty',
          onClick: () => handleSetOrder('loyalty'),
        },
        {
          label: 'Artist',
          icon: 'paint brush',
          id: 'artist',
          onClick: () => handleSetOrder('artist'),
        },
      ]}
    />
  )
}

export default CustomCardsOrderByDropdown
